import type { IUserKeywordGroup } from "app/services/keyword-groups";

import type { KeywordType } from "../types";

const defaultConfig = {
    country: 999,
    duration: "3m",
    webSource: "Total",
    table: "TotalTraffic",
};

export const paramsFindListGroupKeywords = (keyword: KeywordType, defaultParams: Record<string, string | number>) => {
    const params = {
        ...defaultConfig,
        ...defaultParams,
        keyword: "",
    };
    if (keyword.Id) {
        params.keyword = `*${keyword.Id}`;
    } else {
        params.keyword = keyword.name;
    }
    return params;
};

export const sortGroupsKeywords = (a: IUserKeywordGroup, b: IUserKeywordGroup) => {
    if (a.Name.toLowerCase() < b.Name.toLowerCase()) {
        return -1;
    }
    if (a.Name.toLowerCase() > b.Name.toLowerCase()) {
        return 1;
    }
    return 0;
};

export const formatNumberWithComa = (num?: number) =>
    num ? num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "0";
